export default "__VITE_ASSET__tsr7btHx__"